/**
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 */

import { otto } from "../exports/nexus";
import type { OttoNexus } from "../lib/nexus";

/*                      */
export const useAsyncExporter: <N>(
  getNamespace: (otto: OttoNexus) => N,
) => <K extends keyof N>(key: K) => N[K] = /*                      */ (getNamespace) =>
  /*                      */ (
    key,
    ns = getNamespace(otto) ?? ({} as ReturnType<typeof getNamespace>),
  ) =>
    ns[key];

/**
 *
 *
 */
export const asExport = <T, K extends keyof T, D>(
  namespace: T,
  fieldKey: K,
  defaultValue?: D,
): T[K] => namespace[fieldKey] ?? (defaultValue as never);
